module.exports = __webpack_public_path__ + "static/media/30.0eeb0022.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/poinkos/30.jpg
// module id = 563
// module chunks = 0